import {
  IPermissionsContext,
  TPageTypeToPermissionSetMap,
} from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  isDraft,
  isUserAlsoPageOwner,
  isUserAlsoParentCBOwner,
  isUserAlsoParentEBOwner,
} from "../../ipermissions-context/ipermissions-context.functions";
import { enablePermissions, setPermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

function isPageOwnerOrParentOwner(context: IPermissionsContext): boolean {
  return (
    isUserAlsoPageOwner(context) ||
    isUserAlsoParentCBOwner(context) ||
    isUserAlsoParentEBOwner(context)
  );
}

function setCampaignBriefPermissions(context: IPermissionsContext, permissions: IPermissions) {
  setPermissions(
    permissions,
    isUserAlsoPageOwner(context),
    "canEdit",
    "manageExecBriefs",
    "manageProducts",
    "manageStatus",
    "manageWorkOrders",
    "updateReviewStatus"
  );
}

function setExecutionBriefPermissions(context: IPermissionsContext, permissions: IPermissions) {
  setPermissions(
    permissions,
    isUserAlsoPageOwner(context) || isUserAlsoParentCBOwner(context),
    "canEdit",
    "manageExecBriefs",
    "manageProducts",
    "manageReviewers",
    "manageStatus",
    "manageWorkOrders",
    "updateReviewStatus"
  );
}

function setWorkOrderPermissions(context: IPermissionsContext, permissions: IPermissions) {
  setPermissions(
    permissions,
    isUserAlsoPageOwner(context) || isUserAlsoParentEBOwner(context),
    "canEdit",
    "manageExecBriefs",
    "manageProducts",
    "manageReviewers",
    "manageStatus",
    "manageWorkOrders",
    "updateReviewStatus"
  );
}

function setFlyerPermissions(context: IPermissionsContext, permissions: IPermissions) {
  setPermissions(permissions, isUserAlsoPageOwner(context), "canEdit");
  enablePermissions(permissions, "canDelete");
}

const pageTypeToPermissionSetMap: TPageTypeToPermissionSetMap = {
  "campaign-briefs": setCampaignBriefPermissions,
  "execution-briefs": setExecutionBriefPermissions,
  "work-orders": setWorkOrderPermissions,
  flyers: setFlyerPermissions,
};

function getPermissionSet(context: IPermissionsContext): IPermissionPolicyEvaluator {
  return pageTypeToPermissionSetMap[context.pageType!];
}

export const pageOwnerPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkPageOwnerPolicy -->");

  if (isPageOwnerOrParentOwner(context)) {
    // console.log("checkPageOwnerPolicy --> TRUE");
    setPermissions(
      permissions,
      isDraft(context) && isUserAlsoPageOwner(context),
      "canEdit",
      "manageReviewers"
    );

    getPermissionSet(context)(context, permissions);
  }
  if (next) return next(context, permissions);
};
